import { CommonModule } from '@angular/common';
import {Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output} from '@angular/core';
import { FormsModule, ControlContainer, NgForm } from '@angular/forms';
import { BaseComponent } from '@wms/components';
import { isDefined } from '@wm/core';
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  selector: 'wms-toggle',
  standalone: true,
  templateUrl: './wms-toggle.component.html',
  styleUrls: ['./wms-toggle.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    CommonWidgetDirective
  ],
  host: {'class': 'switch'},
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }]
})
export class WmsToggleComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() onValue!: any;
  @Input() offValue!: any;
  @Input() onLabel!: string;
  @Input() offLabel!: string;
  @Output() onChange = new EventEmitter<any>();
  @Output() onFocus = new EventEmitter<any>();
  @Input() model!: any;
  @Input() hideLabels!: boolean;
  @Input() customClasses!: string;
  @Input() id!: string;
  @Input() disabled!: boolean;
  @Input() name?: string;

  checkBoxVal = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.setModelVal();
  }

  ngOnChanges() {
    this.setModelVal();
  }

  setModelVal() {
    if (!isDefined(this.onValue)) {
      this.onValue = true;
    }
    if (!isDefined(this.offValue)) {
      this.offValue = false;
    }
    if (isDefined(this.model)) {
      if (this.model?.toString() === this.onValue.toString()) {
        this.model = true;
      } else if (this.model?.toString() === this.offValue.toString()) {
        this.model = false;
      }
    } else {
      this.model = false;
    }
  }

  handleFocus(event: any) {
    this.onFocus && this.onFocus.emit(event);
  }

  handleChange(checked: any) {
    this.model = (checked === true || checked === this.onValue) ? true : false;

    this.onChange.emit(checked);
  }

}
